import React from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Center, Text, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Device } from 'clipsal-cortex-types/src/api';

export function DetailsConfigurationButton({ device }: { device: Device }) {
  const { id, device_type: deviceType, site_identifier: siteIdentifier } = device;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();

  const handleOnClick = () => {
    const routeEnd = `/power_up_instructions?shouldRegisterDevice=false&deviceId=${id}&direction=forward`;

    switch (deviceType) {
      case 'EV_CHARGER':
        navigate(`../../../../ev-charger/home/device-power-up-instructions`);
        break;
      case 'INVERTER':
        navigate(`../../configure/inverter${routeEnd}`);
        break;
      case 'METER':
        // Providing the SEM serial number here means the user can skip the connect instructions screen so the user -
        // - doesn't need to enter the serial number (we already have the serial number via the site identifier)
        navigate(`../../configure/meter${routeEnd}&serialNumber=${siteIdentifier}`);
        break;
      case 'BATTERY_PACK':
        navigate(`../../configure/tesla`);
        break;
      default:
        toast({
          title: t('Hardware.wifi config unavailable'),
          description: t('Hardware.this feature is currently'),
          status: 'info',
          isClosable: true,
          duration: 5000,
        });
        break;
    }
  };

  return (
    <Center
      justifyContent={'space-between'}
      role={'button'}
      mt={6}
      py={6}
      px={4}
      mx={-5}
      bg={'#E7E6E6'}
      _dark={{
        bg: '#363E40',
      }}
      data-testid="wifi-config-button"
      onClick={handleOnClick}
    >
      <Text>{t('Hardware.config')}</Text>
      <ChevronRightIcon color={'customGrey.400'} h={6} w={6} />
    </Center>
  );
}
